
export default Vue.reactive({
    title: "",
    message: "",
    url: "",
    status: 0
});